import React from "react";

import { useFormikContext } from "formik";

import { Template } from "../../../../../models";

import SwitchContainer from "../../common/SwitchContainer";
import ArticleByInput from "./ArticleByInput";
import IncludeSocialLinksToggle from "./IncludeSocialLinksToggle";

export default function IncludeCreditsToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <div className="space-y-6">
      <SwitchContainer
        title="Include Credits"
        subTitle=""
        tooltip='This will add "Article by", "Original author" and "Source Link" to the bottom of the article.'
        enabled={!!values?.includeCredits}
        setEnabled={() =>
          setFieldValue("includeCredits", !values?.includeCredits)
        }
      />
      <ArticleByInput />
      <IncludeSocialLinksToggle />
    </div>
  );
}
